import * as z from "zod/v4/mini";
import { BrowserRegistry, } from "@gsb-core/client/internal";
import { coreHttpParsers } from "./api/core-http-protocol.js";
import { ProtocolSchemas } from "./utils/protocol-schemas.js";
import { coreAuthProtocol } from "./services/auth/core-auth-protocol.js";
export const coreEntityQuerySchema = z.looseObject({
    status: z.optional(ProtocolSchemas.number()),
    success: z.optional(z.boolean()),
    error: z.optional(z.nullable(z.unknown())),
    entities: z.optional(z.array(z.record(z.string(), z.unknown()))),
    totalCount: z.optional(ProtocolSchemas.number()),
});
const validation = Object.freeze({
    http: coreHttpParsers,
    query: coreEntityQuerySchema,
    auth: coreAuthProtocol,
});
export function registerClientValidation() {
    BrowserRegistry.register("validation", validation);
}
//# sourceMappingURL=client-validation.js.map